import { SelectOption } from "@commonlibs";

export function defaultFilterOption<T>(option: SelectOption<T>, search: string) {
    if (typeof option.label === "string") {
        return option.label.toLowerCase().includes(search.toLowerCase());
    }
    return false;
}

export function createEmptyOptions<T>(label: string): SelectOption<T>[] {
    return [{ label, value: "" }] as SelectOption<T>[];
}
